// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__VV09a","boxTitle":"Qualiphy_boxTitle__2H8pG","box":"Qualiphy_box__1etFE","toggleWrap":"Qualiphy_toggleWrap__1lGIr"};